// Channel-rail copy (ORP-20215). `ReportSectionTabConfig.name` is machine identity — the selection
// key, the persistence key, the platform-logo lookup and, through `tab.channel`, a backend filter
// value. `layoutConfig.types.ts:9-14` says so explicitly: names are identifiers, "NEVER rendered
// raw". The channel rail nevertheless rendered them, title-cased in the component, into
// `aria-label`/`title` and the visible pill — copy derived from an identifier by string surgery,
// which is exactly the v3 conflation v4 exists to undo.
//
// The convention: copy comes from an i18n key, and a tab's own `labelKey` always wins — a layout
// registered by another feature owns its copy in its own namespace. `reports.channels.*` is the
// shared fallback covering the platform names 08's seeded layouts use, so those configs need no
// per-tab key. Distinct identities that mean the same brand collapse onto one key on purpose:
// `GA4` and `Ga4` are two machine names and one product.

const NON_ALPHANUMERIC = /[^a-z0-9]+/giu

/**
 * `'Apple Search Ads'` → `reports.channels.appleSearchAds`. Lower-cases first, so identities that
 * differ only in casing (`GA4` / `Ga4`, `Tiktok` / `TIKTOK`) resolve to the same copy.
 */
export function channelLabelKey(name: string): string {
  const words = name.toLowerCase().split(NON_ALPHANUMERIC).filter(Boolean)
  const [head, ...rest] = words
  if (head === undefined) return ''
  return `reports.channels.${head}${rest.map((word) => word[0]?.toUpperCase() + word.slice(1)).join('')}`
}
